import React, { Component } from 'react';
import styled from 'styled-components';

import WP from 'WP';
import Image from 'partials/Image';
import SmartLink from 'partials/SmartLink';

class Project extends Component {

    render() {
        const imageRatio = window.matchMedia("(max-width: 768px)").matches ? '16:9' : '3:2';
        const { project, gridType, itemHoverBackground } = this.props;
        return (
            <ProjectItem columns={gridType} itemHoverBackground={itemHoverBackground}>
                <SmartLink to={project.link} className="project-link">
                    <Image className="image" image={project.featured_image_src} hoverZoom background ratio={imageRatio} />
                    <section>
                        <div className="title">
                            <h3 dangerouslySetInnerHTML={{ __html: project.acf.title }} />
                        </div>
                        <div className="meta">
                            <div>
                                {project.acf.start_year.trim() && <span className="label">{WP.trans.year || 'År'}</span>}
                                <div className="value">
                                    {project.acf.start_year}
                                    {project.acf.end_year.trim() && <span />}
                                    {project.acf.end_year}
                                </div>
                            </div>
                            <div>
                                <span className="label">{WP.trans.type || 'Type'}</span>
                                <div className="value">{project.category_info.map(cat => cat.name).join(', ')}</div>
                            </div>
                        </div>
                    </section>
                </SmartLink>
            </ProjectItem>
        )
    }
}

export default Project;

const ProjectItem = styled.section`
    position:relative;
    padding: 0 20px;

    .project-link {
        cursor:pointer;
        border:none;
        padding-bottom:0;
    }

    .image {
        @media (max-width: 480px) {
            //width: calc(100% + 50px);
            //margin-left:-25px;
            //margin-right:-25px;
            width:100%;
            padding:0;
            height:190px;
        }
    }

    ${props => props.columns === 2 ? `
        width: 50%;
        margin-bottom:50px; 
        section {
            display:flex;
            flex-wrap: wrap;
            justify-content:space-between;
            padding-top:30px;
            position:relative;
            @media (max-width: 768px) {
                padding-top:20px;
            }
            .title {
                width:50%;
                h3 {
                    font-size:24px;
                    margin-bottom:5px;
                    @media (max-width: 768px) {
                        font-size:21px;
                    }
                }
                .date {
                    font-size:14px;
                    color:#797979;
                }
                @media (max-width: 768px) {
                    width:100%;
                    margin-bottom:15px;
                }
            }
            .meta {
                text-align:center;
                width:50%;
                display:flex;
                @media (max-width: 768px) {
                    width:100%;
                    text-align:left;
                }
                > div {
                    text-align: left;
                    display:inline-block;
                    margin: 0 20px;
                    width:50%;
                    @media (max-width: 768px) {
                        margin: 0 20px 0 0;
                    }
                    .label {
                        display:block;
                        font-size:14px;
                        color:#797979;
                        margin-bottom:5px;
                    }
                    .value {
                        font-size:14px;
                        span {
                            display: inline-block;
                            width:14px;
                            height:1px;
                            background: #000;
                            position:relative;
                            margin: 0 3px;
                            top:-4px;
                        }
                    }
                }
            }
        }
        @media (max-width: 480px) {
            width: 100%;
            margin-bottom:40px;
        }
    ` : ``}

    ${props => props.columns === 4 ? `
        width: 25%;
        margin-bottom:40px; 
        overflow:hidden;
        section {
            position:absolute;
            top:0;
            left:20px;
            right:20px;
            bottom:-2px;
            background: #fff;
            padding: 15px 20px;
            display:flex;
            flex-direction:column;
            justify-content:space-between;
            opacity:0;
            transition: opacity .3s ease-in-out;
            .title {
                transition: transform .3s ease-in-out;
                transform: translateY(-100%);
                h3 {
                    font-size:24px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    @media (min-width: 980px) and (max-width: 1252px) {
                        font-size:20px;
                    }
                }
                .date {
                    display:none;
                }
            }
            .meta {
                display:flex;
                flex-direction:row;
                justify-content:space-between;
                transition: transform .3s ease-in-out;
                transform: translateY(100%);
                > div {
                    min-width:100px;
                }
                .label {
                    display:block;
                    font-size:14px;
                    color:#797979;
                    margin-bottom:5px;
                }
                .value {
                    font-size:14px;
                    span {
                        display: inline-block;
                        width:14px;
                        height:1px;
                        background: #000;
                        position:relative;
                        margin: 0 3px;
                        top:-4px;
                    }
                }
            }
        }
        @media (max-width: 980px) {
            width: 50%;
        }
        @media (max-width: 480px) {
            width: 100%;
        }
    ` : ``}

    ${props => props.itemHoverBackground === 'gray' ? `
        section {
            background: #FAFAFA;
            @media (max-width: 980px) {
                background: #fff;
            }
        }
    ` : ``}

    .project-link:hover {
        ${props => props.columns === 4 ? `
            section {
                opacity: 1;
                .title {
                    transform: translateY(0);
                }
                .meta {
                    transform: translateY(0);
                }
            }
        ` : ``}
    }
`


// WEBPACK FOOTER //
// ./src/partials/Project.js